import { FDBodyText, FDIcon, FDStack } from '@facet-wealth/design';
import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';


const metaOverrides = buildFacetDesignOverride()
  .nameOverride('label', {
    _component: FDBodyText,
  }, overrideReadOnly);

export const OutcomeUsed = ({ resource }) => {
  return (
    <FDStack spacing={1}>
      <FDIcon icon={resource.attr('icon')} />
      <MetaControl attrName={'label'} resource={resource} metaOverrideSet={metaOverrides} />
    </FDStack>
  );
};

OutcomeUsed.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
